import { Component, input } from '@angular/core';
import { IconStar } from '../../icons/i-star';

@Component({
  selector: 'rid-rating-star',
  imports: [IconStar],
  templateUrl: './rid-rating-star.html',
})
export class RidRatingStar {
  filled = input<boolean>(false);
  label = input<string>();
}
